import { render, staticRenderFns } from "./commonInput.vue?vue&type=template&id=53553bc0&scoped=true"
import script from "./commonInput.vue?vue&type=script&lang=js"
export * from "./commonInput.vue?vue&type=script&lang=js"
import style0 from "./commonInput.vue?vue&type=style&index=0&id=53553bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53553bc0",
  null
  
)

export default component.exports